import React, {PropTypes} from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push, goBack } from 'react-router-redux'

// import { Grid, Row, Col, Button, PageHeader } from 'react-bootstrap';
// LOCAL
import { resendMemberInvites, removeMemberPrompt, removeMember, getEnterpriseGroup, getEnterpriseMember } from './actions'

// SHARED
// import LoadIndicator from '../../core/components/LoadIndicator'
import TrashIcon from '../../core/components/TrashIcon'
import ModalRoot from '../../modal/ModalRoot'
import onMount from '../../core/onMount'

import Card, { TitleCard } from '../../core/Card'
import Line from '../../core/Line'
import { ForwardIcon, Icon, PlusIcon, CarIcon } from '../../core/icons'
import EmptyState from '../../core/components/EmptyState'
import { Slider, Select, Button, Col, Row } from 'antd';
import ResendInviteButton from './ResendInviteButton'

import "./Members.css"



const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    ...state.enterprise.members,
    members: [
      ...state.enterprise.members.invited,
      ...state.enterprise.members.members
    ]
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch, //needed for HOC
    onClick: (token_id)=> dispatch(push(`/teams/members/${token_id}`)),
    onResendInvite: (values)=> dispatch(resendMemberInvites(values)),
  }
}

const MemberLine = ({onRemove, onClick, onResendInvite, token_id, name, last, email, accepted, isRemoving}) =>
  <Line onClick={() => accepted==false ? null : onClick(token_id)}>
      <Col span={6}>
        {accepted == false && ('Invite Pending...')}
        {accepted && name}
        {accepted && last}
      </Col>
      <Col span={14}>
        {email}
      </Col>
      <Col span={4}>
        {
          accepted==false ? <ResendInviteButton onResendInvite={(email)=> onResendInvite({emails: email})} email={email} /> : <ForwardIcon/>
        }
      </Col>
  </Line>

const Header = () =>
  <Line className="header">
      <Col span={6}>
        NAME
      </Col>
      <Col span={8}>
        EMAIL
      </Col>
      <Col span={4}>

      </Col>
      <Col span={4}>
        {/* <Row justify="center" type="flex">
          DOWNLOAD
        </Row> */}
      </Col>
  </Line>

const Members = ({onRemove, onClick, match, modal, members, isOwner, isRemoving, onResendInvite}) =>
  <div className="Members">
    <TitleCard sticky>
      <h1>Team Members</h1>
      <Link to="/teams/members/new">
        <Button type="primary" icon="plus" >
          Add Team Member
        </Button>
      </Link>
    </TitleCard>

    <Card>
      <Header />
      { members.map((props, i)=>
          <div>
            <MemberLine key={i} onClick={onClick} onResendInvite={onResendInvite} {...props}/>
          </div>

      )}
      {/* EMPTY STATE */}
      {members.length<1 &&
        <EmptyState
          title="No Members yet."
          buttonLink="/teams/members/new"
          buttonText="Add Team Member"
          buttonIcon='plus'
          icon={CarIcon}
        />
      }
      <span className="footer">
        <span className="results-count">{members.length} results</span>
      </span>
    </Card>
  </div>


const MountedMembers = onMount(({dispatch}) => {
  dispatch(getEnterpriseGroup())
})(Members)

export default connect(mapStateToProps, mapDispatchToProps)(MountedMembers)



// WEBPACK FOOTER //
// ./src/enterprise/members/Members.js